import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-exclusivo-moradores',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './exclusivo-moradores.component.html',
  styleUrls: ['./exclusivo-moradores.component.scss']
})
export class exclusivoMoradoresComponent implements OnInit {

  pageTitle: string | null = null;
  iconPath: string = '';
  showFilterItems: boolean = true;
  showAdditionalFilterItems: boolean = false;
  selectedButton: string = 'todos';
  showSolicitarServico: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.pageTitle = params.get('name');
      this.updateContentBasedOnPage();
      const formattedTitle = this.formataTitulo(this.pageTitle);
      this.iconPath = `/assets/svg/${formattedTitle}.svg`;
    });
  }

  updateContentBasedOnPage(): void {
    if (this.pageTitle === 'Educação') {
    } else if (this.pageTitle === 'Benefícios') {
    }
  }

  formataTitulo(title: string | null): string {
    if (!title) return '';
    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .split(/\s+/)
      .map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }

  navigateToInfo(name: string) {
    this.router.navigate([`/info/${name}`]);
  }

  showAllItems() {
    this.showFilterItems = true;
    this.showAdditionalFilterItems = false;
    this.selectedButton = 'todos';
  }

  showOnlineItems() {
    this.showFilterItems = false;
    this.showAdditionalFilterItems = false;
    this.selectedButton = 'online';
  }

  showPresencialItems() {
    this.showFilterItems = false;
    this.showAdditionalFilterItems = false;
    this.selectedButton = 'presencial';
  }

  showAdditionalItems() {
    this.showAdditionalFilterItems = !this.showAdditionalFilterItems;
    this.showSolicitarServico = this.showAdditionalFilterItems;
  }

  getButtonClass(button: string): string {
    return this.selectedButton === button ? 'botao-azul ativo' : 'botao-azul inativo';
  }
}
